export const FETCH_ALL_USERS = 'FETCH_ALL_USERS';
export const FETCH_SPECIFIC_USERS = 'FETCH_SPECIFIC_USERS';
